export enum AuthOperationUINames {
  'UI_HospitalFlags_CanToggleDoubleBooking' = 'UI_HospitalFlags_CanToggleDoubleBooking',
  'UI_HospitalFlags_CanEditUserRoles' = 'UI_HospitalFlags_CanEditUserRoles',
  'UI_HospitalFlags_CanEditUserLocations' = 'UI_HospitalFlags_CanEditUserLocations',
  'UI_HospitalFlags_CanEditDvmLicenses' = 'UI_HospitalFlags_CanEditDvmLicenses',
  'UI_HospitalFlags_CanEditDvmSchedule' = 'UI_HospitalFlags_CanEditDvmSchedule',
  'UI_HospitalFlags_CanEditDvmSignature' = 'UI_HospitalFlags_CanEditDvmSignature',
  'UI_HospitalFlags_CanEditHospitalDetails' = 'UI_HospitalFlags_CanEditHospitalDetails',
  'UI_HospitalFlags_CanEditHospitalSchedule' = 'UI_HospitalFlags_CanEditHospitalSchedule',
  'UI_HospitalFlags_CanEditAllCommunicationTemplates' = 'UI_HospitalFlags_CanEditAllCommunicationTemplates',
  'UI_HospitalFlags_CanEditLocationCommunicationTemplates' = 'UI_HospitalFlags_CanEditLocationCommunicationTemplates',
  'UI_HospitalFlags_CanEditProviderCommunicationTemplates' = 'UI_HospitalFlags_CanEditProviderCommunicationTemplates',
  'UI_HospitalFlags_CanEditTaskDueDates' = 'UI_HospitalFlags_CanEditTaskDueDates',
  'UI_HospitalFlags_CanReopenVisitWithoutDateRestriction' = 'UI_HospitalFlags_CanReopenVisitWithoutDateRestriction',
  'UI_HospitalFlags_CanAccessHospitalAdmin' = 'UI_HospitalFlags_CanAccessHospitalAdmin',
  'UI_HospitalFlags_CanAccessGlobalAdmin' = 'UI_HospitalFlags_CanAccessGlobalAdmin',
  'UI_HospitalFlags_CanEditAppointmentTypes' = 'UI_HospitalFlags_CanEditAppointmentTypes',
  'UI_HospitalFlags_CanManageClientCommunicationPreferences' = 'UI_HospitalFlags_CanManageClientCommunicationPreferences',
  'UI_HospitalFlags_CanDeleteClientInteractions' = 'UI_HospitalFlags_CanDeleteClientInteractions',
  'UI_HospitalFlags_CanAbortVisit' = 'UI_HospitalFlags_CanAbortVisit',
  'UI_HospitalFlags_CancelPrescriptionPickup' = 'UI_HospitalFlags_CancelPrescriptionPickup',
  'UI_HospitalFlags_CanAddInvoiceDiscrepancy' = 'UI_HospitalFlags_CanAddInvoiceDiscrepancy',
  'UI_HospitalFlags_CancelPetNotPresentInvoice' = 'UI_HospitalFlags_CancelPetNotPresentInvoice',
  'UI_CanOpenFutureClinics' = 'UI_CanOpenFutureClinics',
  'Clinic_CancelClinic' = 'Clinic_CancelClinic',
  'UI_CanSeeFutureAppointments' = 'UI_CanSeeFutureAppointments',
  'Role_PetPass_DVM' = 'Role_PetPass_DVM',
  'Role_PetPass_Admin' = 'Role_PetPass_Admin',
  'UI_CanCancelPendingApprovalPrescriptionRequest' = 'UI_CanCancelPendingApprovalPrescriptionRequest',
  'LabOrder_AddNotesLabResults' = 'LabOrder_AddNotesLabResults',
  'CanUpdateDVMCloseVisit' = 'CanUpdateDVMCloseVisit',
  'UI_CanUsePccSmAnimalIncidentPaymentMethod' = 'UI_CanUsePccSmAnimalIncidentPaymentMethod',
  'UI_CanDeletePetCustomReminder' = 'UI_CanDeletePetCustomReminder',
  'UI_CanReopenClinic' = 'UI_CanReopenClinic',
  'UI_CanCancelReservation' = 'UI_CanCancelReservation',
  'IntegrationConfig_GetRegisteredScheduledJobs' = 'IntegrationConfig_GetRegisteredScheduledJobs',
  'UI_CanUseAdminVisitMode' = 'UI_CanUseAdminVisitMode',
  'UI_CanLaunchCSRFromPetpass' = 'UI_CanLaunchCSRFromPetpass',
  'Clinic_CloseClinic' = 'Clinic_CloseClinic',
  'SalesItem_RemoveSalesItemCacheByClinicId' = 'SalesItem_RemoveSalesItemCacheByClinicId',
  'SalesPackage_RemoveSalesPackageCacheByClinicId' = 'SalesPackage_RemoveSalesPackageCacheByClinicId',
}
